function BagRequired(params1, params2) {
  const newparms1 = parseFloat(params1);
  const newparms2 = parseFloat(params2);

  const total = (newparms1 * newparms2) / 100;
  const subTotalFormatted = parseFloat(total).toFixed(4);
  return subTotalFormatted;
}
module.exports = {
  BagRequired,
};
